import reportsDetailsChartInit from '../theme/charts/echarts/reports-details-chart';

const { docReady } = window.phoenix.utils;

docReady(reportsDetailsChartInit);
